<template>
  <div class="flex-center">
    <i v-on:click="onSocialClick('vk')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'vk']" :style="{fontSize: iconSize}"/>
    </i>
    <i v-on:click="onSocialClick('ig')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'instagram']" :style="{fontSize: iconSize}"/>
    </i>
    <i v-on:click="onSocialClick('gh')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'github']" :style="{fontSize: iconSize}" />
    </i>
    <i v-on:click="onSocialClick('tg')">
      <font-awesome-icon class="icon-3d" :icon="['fab', 'telegram']" :style="{fontSize: iconSize}"/>
    </i>  
  </div>
</template>


<script>
export default {
  name: 'App',
  components: {

  },
  data() {
        return {    
          socialUrls: {
            vk: 'https://vk.com/kzkvv',
            ig: 'https://instagram.com/k8lk',
            gh: 'https://github.com/kzkvv',
            tg: 'https://t.me/BEPHu_kOTA'
          },        
          iconSize: '100px'          
        }
    },
    created() {
      window.addEventListener("resize", this.onInit);
    },
    destroyed() {
      window.removeEventListener("resize", this.onInit);
    },
    methods: {

      onInit() {
        var w = window.innerWidth
        var cf = 7
        if (w < 180) {
          cf = 10
        }
        if (w < 700) {
          this.iconSize = (w / cf).toString(10) + 'px'          
        }
        else {
          this.iconSize = '100px'          
        }     
      },

      onSocialClick(name) {        
        window.open(this.socialUrls[name]);
      }
    },
    mounted() {
      this.onInit()
    }
}
</script>


<style lang="scss">
body {
    margin: 0;
    padding: 0;
  }
#app {
  padding: 0vh;
  margin: 0 !important;
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;  
}

$redColor: rgba(244,67,54,1);
$blueColor:rgba(33,150,243,1);

.flex-center {
  // width: 100%;
  // height: 100%;
  min-height: 100vh;
  
  background: #000;
  
  // display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.flex-bottom {
  // width: 100%;
  // height: 100%;
  min-height: 100vh;
  
  background: #000;
  
  // display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end ;
  -webkit-justify-content: end ;
      -ms-flex-pack: end ;
          justify-content: end ;
  -webkit-box-align: end ;
  -webkit-align-items: end ;
      -ms-flex-align: end ;
          align-items: end ;
}

.icon-3d {
  //width: var(--window.width)
  // height: 20px;
  // size: 10;
  margin-right: 1vh;
  margin-left: 1vh;
  // padding: 10px;
  // -webkit-animation: icon3d 200ms 10;
  // animation: icon3d 200ms 10;
  color: #fff;
  &:hover {
    filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);    
    // color: #f65;    
    // -webkit-animation: icon3d 200ms infinite;
    // animation: icon3d 200ms infinite;
  }
}

// @keyframes icon3d {
//   0% {
//     filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);
//     text-shadow: 5px 4px $redColor, -5px -6px $blueColor;
//   }
//   25% {
//     filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);
//     text-shadow: -5px -6px $redColor, 5px 4px $blueColor;
//   }
//   50% {
//     filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);
//     text-shadow: 5px -4px $redColor, -8px 4px $blueColor;
//   }
//   75% {
//     filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);
//     text-shadow: -8px -4px $redColor, -5px -4px $blueColor;
//   }
//   100% {
//     filter: drop-shadow(-5px -6px 1px $blueColor) drop-shadow(5px 4px 1px $redColor);
//     text-shadow: -5px 0 $redColor, 5px -4px $blueColor;
//   }
// }


</style>

